export const jsonFetcher = (url: string) =>
  fetch(url).then(async (res) => {
    const json = await res.json();
    if (res.ok) {
      return json;
    } else {
      throw new Error(json.message ?? json.error);
    }
  });
